export function formatFileSize(fileSizeInBytes) {
  if (fileSizeInBytes >= 100 * 1024) {
    // Convert to megabytes
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    return `${fileSizeInMB.toFixed(2)} MB`;
  } else {
    // Display in kilobytes
    const fileSizeInKB = fileSizeInBytes / 1024;
    return `${fileSizeInKB.toFixed(2)} KB`;
  }
}
